// Common
import './lib/common/common.js';
// Load Web components
import '../components/kw-button-languages/kw-button-languages.js';
import '../components/kw-footer/kw-footer.js';
import '../components/kw-header/kw-header.js';
import '../components/kw-banner/kw-banner.js';
import '../components/kw-section/kw-section';
import '../components/kw-tab-list/kw-tab-list';
import '../components/kw-title/kw-title';
// Load libraries
import './lib/scroll/scroll.js';

import { CommonTpl } from './pages/common.html.mjs';
import data from '../json/agile.json';
import DataLanguage from './lib/data-language.js';
import dataBanner from './lib/dataBanner.js';
import dataBanners from '../json/agileBannerData.json';

CommonTpl.setData(data);
CommonTpl.detectLanguage();
const { lang } = document.querySelector('html');

const componentName = 'agile';
const texto = CommonTpl.dataLanguage(data.agileData.agileData).sections.methodology.texts;

function banner() {
  const bannerData = document.getElementById('banner-agile');
  bannerData.innerHTML = `
          <kw-banner id="Banner" banner-size="agile" animation-type="slide-toleft" change-interval="8" ">
              ${DataLanguage.dataLanguage(dataBanners.agileBannerData, lang).map(dataBanner.banner).join('')}
          </kw-banner>
    `;
}
function mapTextParagraph(txt) {
  function guardarValor(value) {
    const dato = value.detail.result;
    const changedText = txt.filter((item) => item.name === dato);
    const { title, text } = changedText[0];
    const despliegue = document.querySelector('#description');
    despliegue.innerHTML = `
      <h3 class="section__description-title">${title}</h3>
      <p class="section__description-text">${text}</p>
    `;
  }
  document.addEventListener('change', guardarValor);

  const despliegue = document.querySelector('#description');
  despliegue.innerHTML = `
    <p class="section__description-text">
      ${txt[0].text}
    </p>
  `;
}

function hideCards() {
  if (window.innerWidth < 768) {
    document.getElementById('imagesBenefits').className = 'benefits_hidden-container';
    document.getElementById('imagesBenefits2').className = 'benefits_hidden-container';
  }
}

function casesAnimation() {
  const section = document.querySelector('#case-studies');
  const wrapper = section.querySelector(`.${componentName}__cases-inner`);
  const image = section.querySelector(`.${componentName}__cases-image`);

  const options = {
    threshold: 0.4,
  };
  /* eslint-disable-next-line */
  function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      wrapper.classList.add(`${componentName}__cases-inner--visible`);
      image.classList.add(`${componentName}__cases-image--visible`);
    }
  }

  const observerImages = new IntersectionObserver(callBack, options);
  observerImages.observe(section);
}

function renderCases() {
  document.querySelector('kw-tab-list#agile').addEventListener('kw-tab-list:clicked', ({ detail }) => {
    const { index } = detail;
    const images = document.querySelectorAll(`.${componentName}__cases-image img`);
    images.forEach((image, imageIndex) => {
      // eslint-disable-next-line no-param-reassign
      image.hidden = imageIndex !== parseInt(index, 10);
    });
  });

  casesAnimation();
}

/* animation methodology */
function methodologyAnimation() {
  const section = document.querySelector('#methodology-list');

  const options = {
    threshold: 0.4,
  };
  /* eslint-disable-next-line */
  function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      section.classList.add('section__methodology-layer');
    }
  }

  const observerImages = new IntersectionObserver(callBack, options);
  observerImages.observe(section);
}

function changeMethodologyLayer() {
  methodologyAnimation();
  mapTextParagraph(texto);

  const cbox = document.querySelectorAll('.item');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < cbox.length; i++) {
    cbox[i].addEventListener('click', (event) => {
      const result = event.target.dataset.value;
      const e = new CustomEvent('change', {
        detail: {
          result,
        },
        composed: true,
        bubbles: true,
      });
      document.dispatchEvent(e);
    });
  }
  window.addEventListener('click', (event) => {
    if (!event.target.className.includes('selector')) {
      const despliegue = document.querySelector('#description');
      despliegue.innerHTML = `
        <p class="section__description-text">
          ${texto[0].text}
        </p>
      `;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < cbox.length; i++) {
        cbox[i].classList.add('created');
      }
    }
  });

  /* eslint-disable-next-line */
  for (let [i, cv] of cbox.entries()) {
    cv.addEventListener('click', () => {
      cbox.forEach((el) => el.classList.remove('active', 'created'));
      cv.classList.toggle('active');
    });
  }
}

/* *********************** */
function pillarsAnimation() {
  const section = document.querySelector('#agile_pillars');
  const wrapper = section.querySelector('.agile__pillars');

  const options = {
    threshold: 0.4,
  };
  /* eslint-disable-next-line */
  function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      wrapper.classList.add('agile__pillars-movement');
    }
  }

  const observerImages = new IntersectionObserver(callBack, options);
  observerImages.observe(section);
}

function tabListAnimation() {
  const section = document.querySelector('#agile__tab-list');
  const wrapper = document.querySelector('#agile__tab-list').querySelector('kw-tab-list').shadowRoot.querySelector('.kw-tab-list');
  const options = {
    threshold: 0.4,
  };
    /* eslint-disable-next-line */
    function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      wrapper.classList.add('agile__tab-list--movement');
    }
  }

  const observerImages = new IntersectionObserver(callBack, options);
  observerImages.observe(section);
}

function handleLoadWindowFunctions() {
  banner();
  pillarsAnimation();
  renderCases();
  changeMethodologyLayer();
  hideCards();
  tabListAnimation();
}

if (document.addEventListener) {
  window.addEventListener('load', handleLoadWindowFunctions);
}
